





























import { RoleType, UserPermission } from "@/shared/types";
import {
  Vue,
  Component
} from "@/shared/vuepack";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useEmployerRolePermissionStore } from "@/admin/store/employerRolePermission";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

@Component({ components: {} })
export default class RolePermissionList extends Vue {
  featureFlagStore = useFeatureFlagStore();
  employerRolePermissionStore = useEmployerRolePermissionStore();
  rolePermissionStore = useRolePermissionsStore();

  get canAddPermission (): boolean {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions
        ? this.rolePermissionStore.userHasAdminPermission(UserPermission.AdminPortalUserManagementEdit)
        : true;
  }

  get isRolePermissionsEnabled () {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions;
  }

  get isFeatureFlagAvailable () {
    return this.featureFlagStore.featureFlagsAvailable;
  }

  mounted (): void {
    this.employerRolePermissionStore.getRolesByType(RoleType.Admin);
  }

  addRole () {
    this.$router.push("/role-permissions-management/role-permission-add");
  }
}
